import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import Isvg from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import media from 'decorators/Media/Media';
import { decorateWith, withName } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
var CLOSE_AFTER_MOUSELEAVE_TIME = 750;
export var LINKS = {
  blog: React.createElement("li", null, React.createElement("a", {
    href: "/blog",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "header.link.blog",
    defaultMessage: "Blog"
  }))),
  features: React.createElement("li", null, React.createElement(Link, {
    to: "/features"
  }, React.createElement(FormattedMessage, {
    id: "header.link.features",
    defaultMessage: "How it works"
  }))),
  locations: React.createElement("li", null, React.createElement(Link, {
    to: "/locations"
  }, React.createElement(FormattedMessage, {
    id: "header.link.locations",
    defaultMessage: "Locations"
  }))),
  pricing: React.createElement("li", null, React.createElement(Link, {
    to: "/pricing"
  }, React.createElement(FormattedMessage, {
    id: "header.link.pricing",
    defaultMessage: "Pricing"
  }))),
  search: React.createElement("li", null, React.createElement(Link, {
    to: "/search"
  }, React.createElement(FormattedMessage, {
    id: "header.link.explore",
    defaultMessage: "Explore studios"
  })))
};
export var LINK_ORDERS = {
  DEFAULT: ['locations', 'search', 'features', 'pricing', 'blog'],
  SEARCH: ['locations', 'pricing', 'features', 'search', 'blog'],
  VENUE_DETAIL: ['locations', 'pricing', 'search', 'features', 'blog']
};
export var SellPageLinksUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(SellPageLinksUnwrapped, _Component);

  function SellPageLinksUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SellPageLinksUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SellPageLinksUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dropdownOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      return _this.timer = setTimeout(_this.toggleDropdown, CLOSE_AFTER_MOUSELEAVE_TIME);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      var dropdownOpen = _this.state.dropdownOpen;
      clearTimeout(_this.timer);

      if (!dropdownOpen) {
        _this.toggleDropdown();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function () {
      return _this.setState(function (state) {
        return {
          dropdownOpen: !state.dropdownOpen
        };
      });
    });

    return _this;
  }

  _createClass(SellPageLinksUnwrapped, [{
    key: "renderLink",
    value: function renderLink(name) {
      var link = LINKS[name];
      return link && React.createElement(Fragment, {
        key: name
      }, link);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          collapsedLinks = _this$props.collapsedLinks,
          spreadLinks = _this$props.spreadLinks;
      var dropdownOpen = this.state.dropdownOpen;
      return React.createElement(Fragment, null, spreadLinks.map(this.renderLink), !isEmpty(collapsedLinks) && React.createElement("li", {
        className: "header__dropdown",
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, React.createElement("div", {
        className: classNames({
          header__dropdown__target: true,
          'header__dropdown__target--open': dropdownOpen
        })
      }, React.createElement(FormattedMessage, {
        tagName: "strong",
        id: "nav.more",
        defaultMessage: "More"
      }), React.createElement(Isvg, {
        className: "header__dropdown__arrow svg ml-",
        uniquifyIDs: false,
        src: require('../../../../static/img/arrow.svg')
      })), dropdownOpen && React.createElement("div", {
        className: "header__dropdown__panel"
      }, React.createElement("ul", null, collapsedLinks.map(this.renderLink)))));
    }
  }]);

  return SellPageLinksUnwrapped;
}(Component);
SellPageLinksUnwrapped.propTypes = {
  collapsedLinks: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(LINKS))).isRequired,
  spreadLinks: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(LINKS))).isRequired
};
export var mapStateToProps = function mapStateToProps(state, props) {
  var isSearchPage = props.isSearchPage,
      isVenueDetailPage = props.isVenueDetailPage,
      mediaQueryLg = props.mediaQueryLg,
      mediaQueryXl = props.mediaQueryXl;
  var links = isSearchPage && LINK_ORDERS.SEARCH || isVenueDetailPage && LINK_ORDERS.VENUE_DETAIL || LINK_ORDERS.DEFAULT;
  var shouldCollapseLinks = mediaQueryLg && (isSearchPage || isVenueDetailPage);
  var spreadCount = shouldCollapseLinks ? mediaQueryXl && 2 || mediaQueryLg && 1 || 0 : links.length;
  return {
    collapsedLinks: links.slice(spreadCount),
    spreadLinks: links.slice(0, spreadCount)
  };
};
export var SellPageLinks = decorateWith(connect(mapStateToProps), media, withName('SellPageLinks'))(SellPageLinksUnwrapped);